import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import Keycloak from "keycloak-js";
import axios from "axios";
import router from "./router";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

if (process.env.VUE_APP_ENV === "production") {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["localhost", "absences.heig-vd.ch", /^\//],
      }),
    ],
    tracesSampleRate: 0.4,
  });
}

Vue.config.productionTip = false;

const tokenInterceptor = () => {
  axios.interceptors.request.use(
    (config) => {
      config.headers.Authorization = `Bearer ${Vue.prototype.$keycloak.token}`;
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

const keycloak = new Keycloak({
  url: process.env.VUE_APP_KC_URL,
  realm: process.env.VUE_APP_KC_REALM,
  clientId: process.env.VUE_APP_KC_CLIENT_ID,
});

Vue.prototype.$keycloak = keycloak;

keycloak
  .init({ onLoad: "login-required", checkLoginIframe: false })
  .then(async () => {
    const { data: roles } = await axios({
      method: "get",
      url: `${process.env.VUE_APP_API_URI}/roles`,
    });
    if (
      roles
        .map((r) =>
          keycloak.hasResourceRole(r, process.env.VUE_APP_KC_CLIENT_ID)
        )
        .indexOf(true) === -1
    ) {
      keycloak.logout();
    } else {
      tokenInterceptor();
      new Vue({
        vuetify,
        router,
        render: (h) => h(App),
      }).$mount("#app");
    }

    // Auto-refresh token every 10s (refresh if <30s to expiry)
    setInterval(() => {
      keycloak.updateToken(30).catch(() => keycloak.login());
    }, 10000);
  });
